import { AxiosInstance } from 'axios';
import { plainToInstance } from 'class-transformer';
import { ManagerDTO } from '../commons/dtos/manager.dto';
import { IManager } from '../commons/interfaces/auth.interface';
import {
  IChatbotAPIResponse,
  IChatbotAPIResponsePagination
} from '../commons/interfaces/chatbotAPI.interface';
import { IManagerRequest, IMetadataManager } from '../commons/interfaces/manager.interface';
import Axios from './axios.service';

export default class ManagerAPI {
  private request: AxiosInstance;

  constructor() {
    this.request = Axios.getInstance();
  }

  listManagers = async (page: number) => {
    const response = await this.request.get<IChatbotAPIResponsePagination<IManager[]>>(
      '/managers',
      { params: { pageSize: 10, page } }
    );

    const data = plainToInstance(ManagerDTO, response.data.data);

    return { data, pagination: response.data.pagination };
  };

  createManager = async (managerData: Omit<IManagerRequest, 'newAdminEmail'>) => {
    const response = await this.request.post<IChatbotAPIResponse<IManager>>(
      '/managers',
      managerData
    );

    const data = plainToInstance(ManagerDTO, response.data.data);

    return { data };
  };

  deleteManager = async (managerId: string) => {
    await this.request.delete<Record<string, never>>(`/managers/${managerId}`);
  };

  modifyManager = async (
    managerId: string,
    managerData: Omit<IManagerRequest, 'withNotification'>
  ) => {
    const response = await this.request.patch<IChatbotAPIResponse<IManager>>(
      `/managers/${managerId}`,
      managerData
    );

    const data = plainToInstance(ManagerDTO, response.data.data);

    return { data };
  };

  modifyMetadataManager = async (
    managerId: string,
    managerMetadataData: Partial<IMetadataManager>
  ) => {
    const endpoint = `/managers/${managerId}/metadata`;
    await this.request.patch(endpoint, managerMetadataData);
  };

  modifyMetadataReadingDate = async (managerId: string) => {
    const newData = { notificationReadingDate: new Date() };

    return this.modifyMetadataManager(managerId, newData);
  };
}
